import { defineStore } from "pinia";

import NotificationsApi from "@Modules/shared/Api/NotificationsApi";
import type { TypedNotification } from "@Resources/js/laravel";

/**
 * The notification state the app writes back to the server.
 *
 * The list itself still lives in the legacy Vuex store. What moved here is
 * marking one read, which the two popovers and the priority popup all do.
 */
const XNotifications = defineStore("x-notifications", () => {
  const api = NotificationsApi();

  /**
   * Marks a notification read and, once the server agrees, flips the flag on
   * the very object it was handed. Callers pass the notification the list
   * holds rather than a copy of it, so the checkbox, the popup and the unread
   * badge all follow.
   */
  async function markNotificationAsRead(notification: TypedNotification): Promise<void> {
    const marked = await api.markNotificationAsRead(notification.id);

    if (marked) {
      notification.read = true;
    }
  }

  return {
    markNotificationAsRead,

    /** Swaps the api's router for a fake one when writing tests. */
    setRouter: api.setRouter,
  };
});

export default XNotifications;
